import { render, staticRenderFns } from "./SliderControls.vue?vue&type=template&id=70a74c5a&"
import script from "./SliderControls.vue?vue&type=script&lang=js&"
export * from "./SliderControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SliderControls.vue"
export default component.exports